import { styled } from '../../style';

// This component mainly used insude of Modal.Header for Security Overview modals.
// In ESPP/DSPP Company Plans pages Panel.Header wraps similar component.
// TODO: in future if we standartize headings, this component can be widelly used.
export const CompanyName = styled.div`
  font-size: 16px;
  font-weight: ${(p) => p.theme.fontWeight.normal};
`;
